"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./SaveUp.css");

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _Mouseflow = _interopRequireDefault(require("../../shared/components/Mouseflow"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _MarketingProductNavbar = _interopRequireDefault(require("../components/MarketingProductNavbar"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _OnboardingCard = _interopRequireDefault(require("../components/products/OnboardingCard"));

var _CustomizeBenefits = _interopRequireDefault(require("../components/CustomizeBenefits"));

var _SaveUpTable = _interopRequireDefault(require("../components/saveup/SaveUpTable"));

var _QuoteSelector = _interopRequireWildcard(require("../components/QuoteSelector"));

var _MarketingCarousel = require("../components/MarketingCarousel");

var _MarketingHero = _interopRequireDefault(require("../components/MarketingHero"));

var _LogoGarden = _interopRequireDefault(require("../components/LogoGarden"));

var _Percentage = _interopRequireDefault(require("../components/Percentage"));

var _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Benefit = function Benefit(_ref) {
  var icon = _ref.icon,
      identifier = _ref.identifier;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "benefit"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Benefit Icon",
    src: icon,
    className: "benefit-icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "benefit-section"
  }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    contentKey: "".concat(identifier, "Header"),
    tag: "h2",
    className: "benefit-header"
  }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    contentKey: "".concat(identifier, "Body"),
    tag: "p",
    className: "benefit-body"
  })));
};

var LEGAL_TEXT_KEYS = ["legalText1", "legalText2", "legalText3", "legalText4", "legalText5"];

var SaveUp = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(SaveUp, _React$Component);

  var _super = _createSuper(SaveUp);

  function SaveUp() {
    _classCallCheck(this, SaveUp);

    return _super.apply(this, arguments);
  }

  _createClass(SaveUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Mouseflow.default)();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, {
        enableSubfooter: true,
        defaultProduct: _MarketingCarousel.MARKETING_CARDS.FINCORE,
        legalTextKeys: LEGAL_TEXT_KEYS
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-saveup"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hero-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        className: "background-triangle",
        src: require("../assets/redesign2020/saveup/background-triangle.svg")
      }), /*#__PURE__*/_react.default.createElement(_MarketingHero.default, {
        desktopImage: require("../assets/redesign2020/saveup/desktop-hero.png"),
        tabletImage: require("../assets/redesign2020/saveup/tablet-hero.png"),
        mobileImage: require("../assets/redesign2020/saveup/mobile-hero.png"),
        logo: require("../assets/redesign2020/csu-logo-darker.svg")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "header-subtitle"
      }, "College"), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted saveup"
      }, "SaveUp"), /*#__PURE__*/_react.default.createElement("span", {
        className: "subtitle"
      }, "Help your employees ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "save for their children's education"), " with direct contributions to their 529 college savings plans."))), /*#__PURE__*/_react.default.createElement(_MarketingProductNavbar.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "financial-wellness"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "financial-wellness-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "header"
      }, "A financial wellness benefit ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "for peace of mind"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "wellnessBenefit-1",
        tag: "p",
        className: "paragraph legal-text-1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "wellnessBenefit-2",
        tag: "p",
        className: "paragraph"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "wellnessBenefit-3",
        tag: "p",
        className: "paragraph"
      })), /*#__PURE__*/_react.default.createElement(_SaveUpTable.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "financial-wellness-body-percentages"
      }, /*#__PURE__*/_react.default.createElement(_Percentage.default, {
        index: "1",
        superScript: "legal-text-4"
      }), /*#__PURE__*/_react.default.createElement(_Percentage.default, {
        index: "2",
        superScript: "legal-text-5"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "savings-for-college"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "savings-for-college-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "header"
      }, "Make ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "saving for college"), " simple for your employees."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "collegeSavings",
        tag: "p",
        className: "paragraph"
      })), /*#__PURE__*/_react.default.createElement("img", {
        alt: "College Save Up Family",
        src: require("../assets/redesign2020/saveup/college-savings-family.png"),
        className: "savings-for-college-image"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "how-it-works-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Save Up Chevron",
        src: require("../assets/redesign2020/saveup/save-up-chevron.svg"),
        className: "how-it-works-image"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "how-it-works"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "how-it-works-body-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "how-it-works-body"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "header"
      }, "How ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "College SaveUp"), " works"), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "howItWorks-1",
        tag: "p",
        className: "paragraph"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "howItWorks-2",
        tag: "p",
        className: "paragraph"
      })), /*#__PURE__*/_react.default.createElement("img", {
        alt: "How It Works Chevrons",
        src: require("../assets/redesign2020/saveup/how-it-works-chevrons.svg"),
        className: "how-it-works-body-image"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "how-it-works-plan-benefits"
      }, /*#__PURE__*/_react.default.createElement(Benefit, {
        icon: require("../assets/redesign2020/saveup/contributions-icon.svg"),
        identifier: "contribution"
      }), /*#__PURE__*/_react.default.createElement(Benefit, {
        icon: require("../assets/redesign2020/saveup/choices-icon.svg"),
        identifier: "choices"
      }), /*#__PURE__*/_react.default.createElement(Benefit, {
        icon: require("../assets/redesign2020/saveup/benefits-icon.svg"),
        identifier: "proactiveBenefits"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "onboard-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "onboarding-background"
      }), /*#__PURE__*/_react.default.createElement(_OnboardingCard.default, null)), /*#__PURE__*/_react.default.createElement(_QuoteSelector.default, {
        defaultQuote: _QuoteSelector.QUOTE_CARDS.CSU
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-benefits-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_CustomizeBenefits.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "logo-garden-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_LogoGarden.default, null)))));
    }
  }]);

  return SaveUp;
}(_react.default.Component)) || _class;

var _default = (0, _MobxView.default)((0, _Propulator.default)(SaveUp, {}));

exports.default = _default;